Ext.define('SA.CrosstabDataProxy', {
    maxAttributesPerSidePerRequest: 20, 

    constructor({location, onResults}) {
        this.pending = new Set();

        this.location = location;
        this.resultsHandler = onResults;
    },

    performRequest({top: vertical, left: horizontal}) {
        var weight = 'respondent',
            data = {weight, locationSeries: this.location, vertical, horizontal};

        return SA.Ajax.request({resource: 'data/crosstab', data});
    },

    async request(attributes) {
        attributes.filterLists(this.pending.values());

        if (attributes.isEmpty()) {
            return []; 
        }

        this.pending.add(attributes);

        await this.requestInBatches(attributes);

        this.pending.delete(attributes);
    },

    async requestInBatches(attributes) {
        var batches = attributes.getBatches(this.maxAttributesPerSidePerRequest);

        while (batches.length > 0) {
            let attributes = batches.shift(),
                response = await this.performRequest(attributes),
                result = SA.CrosstabResponseMapper.map({attributes, response});

            this.resultsHandler(result);
        }
    }
});